const GOOGLE_FONTS_API_URL = "https://www.googleapis.com/webfonts/v1/webfonts";
export async function fetchGoogleFontFamilies() {
    const key = process.env.VUE_APP_GOOGLE_FONTS_API_KEY;
    if (!key)
        throw new Error("VUE_APP_GOOGLE_FONTS_API_KEY is not configured");
    const res = await fetch(`${GOOGLE_FONTS_API_URL}?key=${key}&sort=popularity`);
    if (!res.ok)
        throw new Error("Failed to fetch Google Fonts");
    const data = await res.json();
    return (data.items ?? []).map((item) => ({
        family: item.family,
        category: item.category,
        variants: item.variants,
    }));
}
